export default "__VITE_PUBLIC_ASSET__02a477ac__"